module.exports = __webpack_public_path__ + "img/choctaw.366deadd.png";